import ApiService from '@/services/ApiService';

const API_URL = '/api/Admin/ImportPartnerData/';

class AdminImportPartnerService {
  importGutshofOrders() {
    return ApiService.post(`${API_URL}ImportGutshofOrders`, {});
  }
  importGutshofVouchers() {
    return ApiService.post(`${API_URL}ImportGutshofVouchers`, {});
  }
  deleteGutshofOrders() {
    return ApiService.delete(`${API_URL}DeleteGutshofOrders`);
  }
  deleteGutshofVouchers() {
    return ApiService.delete(`${API_URL}DeleteGutshofVouchers`);
  }
}

export default new AdminImportPartnerService();
